var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"flex items-center mt-6 space-x-4 sm:justify-between sm:mt-0"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }